import {
  ErrorFilled,
  Info,
  SuccessFilled,
  WarningFilled,
} from "@/assets/icons";
import { ToastType } from "@/components/toast/types";
import { Loader } from "@/components/loader";

export const Icons = {
  [ToastType.Success]: <SuccessFilled />,
  [ToastType.Error]: <ErrorFilled />,
  [ToastType.Warning]: <WarningFilled />,
  [ToastType.Info]: <Info />,
  [ToastType.Loading]: <Loader />,
  [ToastType.Acrylic]: <Info />,
  [ToastType.Default]: <Info />,
};
